import { FormCompletion } from "client/domain";

export const allBusinessDetailsFormsComplete = ({
  businessOwnerForm,
  companyInfoForm,
  storeDetailsForm,
  storeForm,
}: FormCompletion): boolean => {
  /**
   * Until salesforce data patch occurs, if a legacy merchant
   * has completed the MOP, storeForm will be complete but all others
   * will not be. This handles that edge case. This entire if block will
   * be removed after salesforce data patch.
   */
  if (
    !companyInfoForm &&
    !storeDetailsForm &&
    !businessOwnerForm &&
    storeForm
  ) {
    return true;
  }
  return businessOwnerForm && storeDetailsForm && companyInfoForm;
};

export const hasSubmittedLeadForm = (): boolean | null =>
  JSON.parse(window?.localStorage?.getItem("hasSubmittedLead") ?? "false");
